import Link from 'next/link';

import useTranslation from '@/utils/hooks/translation/useTranslation';
// Utils
import useUserRole from '@/utils/hooks/user/useUserRole';

// Lib
import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';

// Types
import type { TooltipProps } from '@/components/base/Tooltip';
// Components
import Tooltip from '@/components/base/Tooltip';
import { Trans } from '@/components/tools/translation';

type TooltipPlanRestrictionProps = Omit<TooltipProps, 'content' | 'interactive' | 'appendTo'>;

export function TooltipPlanRestriction({ position, ...restProps }: TooltipPlanRestrictionProps) {
    if (typeof document === 'undefined') {
        return null;
    }

    return (
        <Tooltip
            interactive
            position={position ?? 'right'}
            appendTo={document.body}
            content={<TooltipPlanRestrictionContent />}
            {...restProps}
        />
    );
}

export function TooltipPlanRestrictionContent(props: { href?: string; onClick?: () => void }) {
    const { href = SUBSCRIPTION_INVOICES, onClick } = props;
    const { t } = useTranslation('commons');
    const { isAdmin } = useUserRole();

    if (!isAdmin) {
        return t('upgrade_plan_tooltip.team_member');
    }

    return (
        <Trans
            i18nKey="commons:upgrade_plan_tooltip.admin"
            components={{
                link: href ? (
                    <Link className="text-icoBlue" href={href} />
                ) : (
                    <button className="text-icoBlue" onClick={onClick} />
                )
            }}
        />
    );
}
